/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as IndexRouteImport } from './routes/index'
import { Route as BBusinessIdRouteImport } from './routes/b/$businessId'
import { Route as AuthOperatorRouteImport } from './routes/_auth.operator'
import { Route as AuthOperatorIndexRouteImport } from './routes/_auth.operator/index'
import { Route as AuthOperatorWaitlistRouteImport } from './routes/_auth.operator/waitlist'
import { Route as AuthOperatorTemplatesRouteImport } from './routes/_auth.operator/templates'
import { Route as AuthOperatorStaffRouteImport } from './routes/_auth.operator/staff'
import { Route as AuthOperatorSettingsRouteImport } from './routes/_auth.operator/settings'
import { Route as AuthOperatorServicesRouteImport } from './routes/_auth.operator/services'
import { Route as AuthOperatorReviewsRouteImport } from './routes/_auth.operator/reviews'
import { Route as AuthOperatorPhoneHealthRouteImport } from './routes/_auth.operator/phone-health'
import { Route as AuthOperatorOnboardingRouteImport } from './routes/_auth.operator/onboarding'
import { Route as AuthOperatorNoShowsRouteImport } from './routes/_auth.operator/no-shows'
import { Route as AuthOperatorIntegrationsRouteImport } from './routes/_auth.operator/integrations'
import { Route as AuthOperatorFlowsRouteImport } from './routes/_auth.operator/flows'
import { Route as AuthOperatorDeliveriesRouteImport } from './routes/_auth.operator/deliveries'
import { Route as AuthOperatorDashboardRouteImport } from './routes/_auth.operator/dashboard'
import { Route as AuthOperatorCopilotSettingsRouteImport } from './routes/_auth.operator/copilot-settings'
import { Route as AuthOperatorComplianceRouteImport } from './routes/_auth.operator/compliance'
import { Route as AuthOperatorCatalogRouteImport } from './routes/_auth.operator/catalog'
import { Route as AuthOperatorCalendarRouteImport } from './routes/_auth.operator/calendar'
import { Route as AuthOperatorBroadcastsRouteImport } from './routes/_auth.operator/broadcasts'
import { Route as AuthOperatorAuditLogsRouteImport } from './routes/_auth.operator/audit-logs'
import { Route as AuthOperatorAiSearchRouteImport } from './routes/_auth.operator/ai-search'
import { Route as AuthOperatorPaymentsIndexRouteImport } from './routes/_auth.operator/payments/index'
import { Route as AuthOperatorOrdersIndexRouteImport } from './routes/_auth.operator/orders/index'
import { Route as AuthOperatorCustomersIndexRouteImport } from './routes/_auth.operator/customers/index'
import { Route as AuthOperatorConversationsIndexRouteImport } from './routes/_auth.operator/conversations/index'
import { Route as AuthOperatorBookingsIndexRouteImport } from './routes/_auth.operator/bookings/index'
import { Route as AuthOperatorPaymentsIdRouteImport } from './routes/_auth.operator/payments/$id'
import { Route as AuthOperatorOrdersIdRouteImport } from './routes/_auth.operator/orders/$id'
import { Route as AuthOperatorCustomersIdRouteImport } from './routes/_auth.operator/customers/$id'
import { Route as AuthOperatorConversationsIdRouteImport } from './routes/_auth.operator/conversations/$id'
import { Route as AuthOperatorBookingsIdRouteImport } from './routes/_auth.operator/bookings/$id'

const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const BBusinessIdRoute = BBusinessIdRouteImport.update({
  id: '/b/$businessId',
  path: '/b/$businessId',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthOperatorRoute = AuthOperatorRouteImport.update({
  id: '/operator',
  path: '/operator',
  getParentRoute: () => AuthRoute,
} as any)
const AuthOperatorIndexRoute = AuthOperatorIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthOperatorRoute,
} as any)
const AuthOperatorWaitlistRoute = AuthOperatorWaitlistRouteImport.update({
  id: '/waitlist',
  path: '/waitlist',
  getParentRoute: () => AuthOperatorRoute,
} as any)
const AuthOperatorTemplatesRoute = AuthOperatorTemplatesRouteImport.update({
  id: '/templates',
  path: '/templates',
  getParentRoute: () => AuthOperatorRoute,
} as any)
const AuthOperatorStaffRoute = AuthOperatorStaffRouteImport.update({
  id: '/staff',
  path: '/staff',
  getParentRoute: () => AuthOperatorRoute,
} as any)
const AuthOperatorSettingsRoute = AuthOperatorSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthOperatorRoute,
} as any)
const AuthOperatorServicesRoute = AuthOperatorServicesRouteImport.update({
  id: '/services',
  path: '/services',
  getParentRoute: () => AuthOperatorRoute,
} as any)
const AuthOperatorReviewsRoute = AuthOperatorReviewsRouteImport.update({
  id: '/reviews',
  path: '/reviews',
  getParentRoute: () => AuthOperatorRoute,
} as any)
const AuthOperatorPhoneHealthRoute = AuthOperatorPhoneHealthRouteImport.update({
  id: '/phone-health',
  path: '/phone-health',
  getParentRoute: () => AuthOperatorRoute,
} as any)
const AuthOperatorOnboardingRoute = AuthOperatorOnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => AuthOperatorRoute,
} as any)
const AuthOperatorNoShowsRoute = AuthOperatorNoShowsRouteImport.update({
  id: '/no-shows',
  path: '/no-shows',
  getParentRoute: () => AuthOperatorRoute,
} as any)
const AuthOperatorIntegrationsRoute =
  AuthOperatorIntegrationsRouteImport.update({
    id: '/integrations',
    path: '/integrations',
    getParentRoute: () => AuthOperatorRoute,
  } as any)
const AuthOperatorFlowsRoute = AuthOperatorFlowsRouteImport.update({
  id: '/flows',
  path: '/flows',
  getParentRoute: () => AuthOperatorRoute,
} as any)
const AuthOperatorDeliveriesRoute = AuthOperatorDeliveriesRouteImport.update({
  id: '/deliveries',
  path: '/deliveries',
  getParentRoute: () => AuthOperatorRoute,
} as any)
const AuthOperatorDashboardRoute = AuthOperatorDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthOperatorRoute,
} as any)
const AuthOperatorCopilotSettingsRoute =
  AuthOperatorCopilotSettingsRouteImport.update({
    id: '/copilot-settings',
    path: '/copilot-settings',
    getParentRoute: () => AuthOperatorRoute,
  } as any)
const AuthOperatorComplianceRoute = AuthOperatorComplianceRouteImport.update({
  id: '/compliance',
  path: '/compliance',
  getParentRoute: () => AuthOperatorRoute,
} as any)
const AuthOperatorCatalogRoute = AuthOperatorCatalogRouteImport.update({
  id: '/catalog',
  path: '/catalog',
  getParentRoute: () => AuthOperatorRoute,
} as any)
const AuthOperatorCalendarRoute = AuthOperatorCalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => AuthOperatorRoute,
} as any)
const AuthOperatorBroadcastsRoute = AuthOperatorBroadcastsRouteImport.update({
  id: '/broadcasts',
  path: '/broadcasts',
  getParentRoute: () => AuthOperatorRoute,
} as any)
const AuthOperatorAuditLogsRoute = AuthOperatorAuditLogsRouteImport.update({
  id: '/audit-logs',
  path: '/audit-logs',
  getParentRoute: () => AuthOperatorRoute,
} as any)
const AuthOperatorAiSearchRoute = AuthOperatorAiSearchRouteImport.update({
  id: '/ai-search',
  path: '/ai-search',
  getParentRoute: () => AuthOperatorRoute,
} as any)
const AuthOperatorPaymentsIndexRoute =
  AuthOperatorPaymentsIndexRouteImport.update({
    id: '/payments/',
    path: '/payments/',
    getParentRoute: () => AuthOperatorRoute,
  } as any)
const AuthOperatorOrdersIndexRoute = AuthOperatorOrdersIndexRouteImport.update({
  id: '/orders/',
  path: '/orders/',
  getParentRoute: () => AuthOperatorRoute,
} as any)
const AuthOperatorCustomersIndexRoute =
  AuthOperatorCustomersIndexRouteImport.update({
    id: '/customers/',
    path: '/customers/',
    getParentRoute: () => AuthOperatorRoute,
  } as any)
const AuthOperatorConversationsIndexRoute =
  AuthOperatorConversationsIndexRouteImport.update({
    id: '/conversations/',
    path: '/conversations/',
    getParentRoute: () => AuthOperatorRoute,
  } as any)
const AuthOperatorBookingsIndexRoute =
  AuthOperatorBookingsIndexRouteImport.update({
    id: '/bookings/',
    path: '/bookings/',
    getParentRoute: () => AuthOperatorRoute,
  } as any)
const AuthOperatorPaymentsIdRoute = AuthOperatorPaymentsIdRouteImport.update({
  id: '/payments/$id',
  path: '/payments/$id',
  getParentRoute: () => AuthOperatorRoute,
} as any)
const AuthOperatorOrdersIdRoute = AuthOperatorOrdersIdRouteImport.update({
  id: '/orders/$id',
  path: '/orders/$id',
  getParentRoute: () => AuthOperatorRoute,
} as any)
const AuthOperatorCustomersIdRoute = AuthOperatorCustomersIdRouteImport.update({
  id: '/customers/$id',
  path: '/customers/$id',
  getParentRoute: () => AuthOperatorRoute,
} as any)
const AuthOperatorConversationsIdRoute =
  AuthOperatorConversationsIdRouteImport.update({
    id: '/conversations/$id',
    path: '/conversations/$id',
    getParentRoute: () => AuthOperatorRoute,
  } as any)
const AuthOperatorBookingsIdRoute = AuthOperatorBookingsIdRouteImport.update({
  id: '/bookings/$id',
  path: '/bookings/$id',
  getParentRoute: () => AuthOperatorRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/sign-in': typeof SignInRoute
  '/operator': typeof AuthOperatorRouteWithChildren
  '/b/$businessId': typeof BBusinessIdRoute
  '/operator/ai-search': typeof AuthOperatorAiSearchRoute
  '/operator/audit-logs': typeof AuthOperatorAuditLogsRoute
  '/operator/broadcasts': typeof AuthOperatorBroadcastsRoute
  '/operator/calendar': typeof AuthOperatorCalendarRoute
  '/operator/catalog': typeof AuthOperatorCatalogRoute
  '/operator/compliance': typeof AuthOperatorComplianceRoute
  '/operator/copilot-settings': typeof AuthOperatorCopilotSettingsRoute
  '/operator/dashboard': typeof AuthOperatorDashboardRoute
  '/operator/deliveries': typeof AuthOperatorDeliveriesRoute
  '/operator/flows': typeof AuthOperatorFlowsRoute
  '/operator/integrations': typeof AuthOperatorIntegrationsRoute
  '/operator/no-shows': typeof AuthOperatorNoShowsRoute
  '/operator/onboarding': typeof AuthOperatorOnboardingRoute
  '/operator/phone-health': typeof AuthOperatorPhoneHealthRoute
  '/operator/reviews': typeof AuthOperatorReviewsRoute
  '/operator/services': typeof AuthOperatorServicesRoute
  '/operator/settings': typeof AuthOperatorSettingsRoute
  '/operator/staff': typeof AuthOperatorStaffRoute
  '/operator/templates': typeof AuthOperatorTemplatesRoute
  '/operator/waitlist': typeof AuthOperatorWaitlistRoute
  '/operator/': typeof AuthOperatorIndexRoute
  '/operator/bookings/$id': typeof AuthOperatorBookingsIdRoute
  '/operator/conversations/$id': typeof AuthOperatorConversationsIdRoute
  '/operator/customers/$id': typeof AuthOperatorCustomersIdRoute
  '/operator/orders/$id': typeof AuthOperatorOrdersIdRoute
  '/operator/payments/$id': typeof AuthOperatorPaymentsIdRoute
  '/operator/bookings/': typeof AuthOperatorBookingsIndexRoute
  '/operator/conversations/': typeof AuthOperatorConversationsIndexRoute
  '/operator/customers/': typeof AuthOperatorCustomersIndexRoute
  '/operator/orders/': typeof AuthOperatorOrdersIndexRoute
  '/operator/payments/': typeof AuthOperatorPaymentsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/sign-in': typeof SignInRoute
  '/b/$businessId': typeof BBusinessIdRoute
  '/operator/ai-search': typeof AuthOperatorAiSearchRoute
  '/operator/audit-logs': typeof AuthOperatorAuditLogsRoute
  '/operator/broadcasts': typeof AuthOperatorBroadcastsRoute
  '/operator/calendar': typeof AuthOperatorCalendarRoute
  '/operator/catalog': typeof AuthOperatorCatalogRoute
  '/operator/compliance': typeof AuthOperatorComplianceRoute
  '/operator/copilot-settings': typeof AuthOperatorCopilotSettingsRoute
  '/operator/dashboard': typeof AuthOperatorDashboardRoute
  '/operator/deliveries': typeof AuthOperatorDeliveriesRoute
  '/operator/flows': typeof AuthOperatorFlowsRoute
  '/operator/integrations': typeof AuthOperatorIntegrationsRoute
  '/operator/no-shows': typeof AuthOperatorNoShowsRoute
  '/operator/onboarding': typeof AuthOperatorOnboardingRoute
  '/operator/phone-health': typeof AuthOperatorPhoneHealthRoute
  '/operator/reviews': typeof AuthOperatorReviewsRoute
  '/operator/services': typeof AuthOperatorServicesRoute
  '/operator/settings': typeof AuthOperatorSettingsRoute
  '/operator/staff': typeof AuthOperatorStaffRoute
  '/operator/templates': typeof AuthOperatorTemplatesRoute
  '/operator/waitlist': typeof AuthOperatorWaitlistRoute
  '/operator': typeof AuthOperatorIndexRoute
  '/operator/bookings/$id': typeof AuthOperatorBookingsIdRoute
  '/operator/conversations/$id': typeof AuthOperatorConversationsIdRoute
  '/operator/customers/$id': typeof AuthOperatorCustomersIdRoute
  '/operator/orders/$id': typeof AuthOperatorOrdersIdRoute
  '/operator/payments/$id': typeof AuthOperatorPaymentsIdRoute
  '/operator/bookings': typeof AuthOperatorBookingsIndexRoute
  '/operator/conversations': typeof AuthOperatorConversationsIndexRoute
  '/operator/customers': typeof AuthOperatorCustomersIndexRoute
  '/operator/orders': typeof AuthOperatorOrdersIndexRoute
  '/operator/payments': typeof AuthOperatorPaymentsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteWithChildren
  '/sign-in': typeof SignInRoute
  '/_auth/operator': typeof AuthOperatorRouteWithChildren
  '/b/$businessId': typeof BBusinessIdRoute
  '/_auth/operator/ai-search': typeof AuthOperatorAiSearchRoute
  '/_auth/operator/audit-logs': typeof AuthOperatorAuditLogsRoute
  '/_auth/operator/broadcasts': typeof AuthOperatorBroadcastsRoute
  '/_auth/operator/calendar': typeof AuthOperatorCalendarRoute
  '/_auth/operator/catalog': typeof AuthOperatorCatalogRoute
  '/_auth/operator/compliance': typeof AuthOperatorComplianceRoute
  '/_auth/operator/copilot-settings': typeof AuthOperatorCopilotSettingsRoute
  '/_auth/operator/dashboard': typeof AuthOperatorDashboardRoute
  '/_auth/operator/deliveries': typeof AuthOperatorDeliveriesRoute
  '/_auth/operator/flows': typeof AuthOperatorFlowsRoute
  '/_auth/operator/integrations': typeof AuthOperatorIntegrationsRoute
  '/_auth/operator/no-shows': typeof AuthOperatorNoShowsRoute
  '/_auth/operator/onboarding': typeof AuthOperatorOnboardingRoute
  '/_auth/operator/phone-health': typeof AuthOperatorPhoneHealthRoute
  '/_auth/operator/reviews': typeof AuthOperatorReviewsRoute
  '/_auth/operator/services': typeof AuthOperatorServicesRoute
  '/_auth/operator/settings': typeof AuthOperatorSettingsRoute
  '/_auth/operator/staff': typeof AuthOperatorStaffRoute
  '/_auth/operator/templates': typeof AuthOperatorTemplatesRoute
  '/_auth/operator/waitlist': typeof AuthOperatorWaitlistRoute
  '/_auth/operator/': typeof AuthOperatorIndexRoute
  '/_auth/operator/bookings/$id': typeof AuthOperatorBookingsIdRoute
  '/_auth/operator/conversations/$id': typeof AuthOperatorConversationsIdRoute
  '/_auth/operator/customers/$id': typeof AuthOperatorCustomersIdRoute
  '/_auth/operator/orders/$id': typeof AuthOperatorOrdersIdRoute
  '/_auth/operator/payments/$id': typeof AuthOperatorPaymentsIdRoute
  '/_auth/operator/bookings/': typeof AuthOperatorBookingsIndexRoute
  '/_auth/operator/conversations/': typeof AuthOperatorConversationsIndexRoute
  '/_auth/operator/customers/': typeof AuthOperatorCustomersIndexRoute
  '/_auth/operator/orders/': typeof AuthOperatorOrdersIndexRoute
  '/_auth/operator/payments/': typeof AuthOperatorPaymentsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/sign-in'
    | '/operator'
    | '/b/$businessId'
    | '/operator/ai-search'
    | '/operator/audit-logs'
    | '/operator/broadcasts'
    | '/operator/calendar'
    | '/operator/catalog'
    | '/operator/compliance'
    | '/operator/copilot-settings'
    | '/operator/dashboard'
    | '/operator/deliveries'
    | '/operator/flows'
    | '/operator/integrations'
    | '/operator/no-shows'
    | '/operator/onboarding'
    | '/operator/phone-health'
    | '/operator/reviews'
    | '/operator/services'
    | '/operator/settings'
    | '/operator/staff'
    | '/operator/templates'
    | '/operator/waitlist'
    | '/operator/'
    | '/operator/bookings/$id'
    | '/operator/conversations/$id'
    | '/operator/customers/$id'
    | '/operator/orders/$id'
    | '/operator/payments/$id'
    | '/operator/bookings/'
    | '/operator/conversations/'
    | '/operator/customers/'
    | '/operator/orders/'
    | '/operator/payments/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/sign-in'
    | '/b/$businessId'
    | '/operator/ai-search'
    | '/operator/audit-logs'
    | '/operator/broadcasts'
    | '/operator/calendar'
    | '/operator/catalog'
    | '/operator/compliance'
    | '/operator/copilot-settings'
    | '/operator/dashboard'
    | '/operator/deliveries'
    | '/operator/flows'
    | '/operator/integrations'
    | '/operator/no-shows'
    | '/operator/onboarding'
    | '/operator/phone-health'
    | '/operator/reviews'
    | '/operator/services'
    | '/operator/settings'
    | '/operator/staff'
    | '/operator/templates'
    | '/operator/waitlist'
    | '/operator'
    | '/operator/bookings/$id'
    | '/operator/conversations/$id'
    | '/operator/customers/$id'
    | '/operator/orders/$id'
    | '/operator/payments/$id'
    | '/operator/bookings'
    | '/operator/conversations'
    | '/operator/customers'
    | '/operator/orders'
    | '/operator/payments'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/sign-in'
    | '/_auth/operator'
    | '/b/$businessId'
    | '/_auth/operator/ai-search'
    | '/_auth/operator/audit-logs'
    | '/_auth/operator/broadcasts'
    | '/_auth/operator/calendar'
    | '/_auth/operator/catalog'
    | '/_auth/operator/compliance'
    | '/_auth/operator/copilot-settings'
    | '/_auth/operator/dashboard'
    | '/_auth/operator/deliveries'
    | '/_auth/operator/flows'
    | '/_auth/operator/integrations'
    | '/_auth/operator/no-shows'
    | '/_auth/operator/onboarding'
    | '/_auth/operator/phone-health'
    | '/_auth/operator/reviews'
    | '/_auth/operator/services'
    | '/_auth/operator/settings'
    | '/_auth/operator/staff'
    | '/_auth/operator/templates'
    | '/_auth/operator/waitlist'
    | '/_auth/operator/'
    | '/_auth/operator/bookings/$id'
    | '/_auth/operator/conversations/$id'
    | '/_auth/operator/customers/$id'
    | '/_auth/operator/orders/$id'
    | '/_auth/operator/payments/$id'
    | '/_auth/operator/bookings/'
    | '/_auth/operator/conversations/'
    | '/_auth/operator/customers/'
    | '/_auth/operator/orders/'
    | '/_auth/operator/payments/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRouteWithChildren
  SignInRoute: typeof SignInRoute
  BBusinessIdRoute: typeof BBusinessIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/b/$businessId': {
      id: '/b/$businessId'
      path: '/b/$businessId'
      fullPath: '/b/$businessId'
      preLoaderRoute: typeof BBusinessIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/operator': {
      id: '/_auth/operator'
      path: '/operator'
      fullPath: '/operator'
      preLoaderRoute: typeof AuthOperatorRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/operator/': {
      id: '/_auth/operator/'
      path: '/'
      fullPath: '/operator/'
      preLoaderRoute: typeof AuthOperatorIndexRouteImport
      parentRoute: typeof AuthOperatorRoute
    }
    '/_auth/operator/waitlist': {
      id: '/_auth/operator/waitlist'
      path: '/waitlist'
      fullPath: '/operator/waitlist'
      preLoaderRoute: typeof AuthOperatorWaitlistRouteImport
      parentRoute: typeof AuthOperatorRoute
    }
    '/_auth/operator/templates': {
      id: '/_auth/operator/templates'
      path: '/templates'
      fullPath: '/operator/templates'
      preLoaderRoute: typeof AuthOperatorTemplatesRouteImport
      parentRoute: typeof AuthOperatorRoute
    }
    '/_auth/operator/staff': {
      id: '/_auth/operator/staff'
      path: '/staff'
      fullPath: '/operator/staff'
      preLoaderRoute: typeof AuthOperatorStaffRouteImport
      parentRoute: typeof AuthOperatorRoute
    }
    '/_auth/operator/settings': {
      id: '/_auth/operator/settings'
      path: '/settings'
      fullPath: '/operator/settings'
      preLoaderRoute: typeof AuthOperatorSettingsRouteImport
      parentRoute: typeof AuthOperatorRoute
    }
    '/_auth/operator/services': {
      id: '/_auth/operator/services'
      path: '/services'
      fullPath: '/operator/services'
      preLoaderRoute: typeof AuthOperatorServicesRouteImport
      parentRoute: typeof AuthOperatorRoute
    }
    '/_auth/operator/reviews': {
      id: '/_auth/operator/reviews'
      path: '/reviews'
      fullPath: '/operator/reviews'
      preLoaderRoute: typeof AuthOperatorReviewsRouteImport
      parentRoute: typeof AuthOperatorRoute
    }
    '/_auth/operator/phone-health': {
      id: '/_auth/operator/phone-health'
      path: '/phone-health'
      fullPath: '/operator/phone-health'
      preLoaderRoute: typeof AuthOperatorPhoneHealthRouteImport
      parentRoute: typeof AuthOperatorRoute
    }
    '/_auth/operator/onboarding': {
      id: '/_auth/operator/onboarding'
      path: '/onboarding'
      fullPath: '/operator/onboarding'
      preLoaderRoute: typeof AuthOperatorOnboardingRouteImport
      parentRoute: typeof AuthOperatorRoute
    }
    '/_auth/operator/no-shows': {
      id: '/_auth/operator/no-shows'
      path: '/no-shows'
      fullPath: '/operator/no-shows'
      preLoaderRoute: typeof AuthOperatorNoShowsRouteImport
      parentRoute: typeof AuthOperatorRoute
    }
    '/_auth/operator/integrations': {
      id: '/_auth/operator/integrations'
      path: '/integrations'
      fullPath: '/operator/integrations'
      preLoaderRoute: typeof AuthOperatorIntegrationsRouteImport
      parentRoute: typeof AuthOperatorRoute
    }
    '/_auth/operator/flows': {
      id: '/_auth/operator/flows'
      path: '/flows'
      fullPath: '/operator/flows'
      preLoaderRoute: typeof AuthOperatorFlowsRouteImport
      parentRoute: typeof AuthOperatorRoute
    }
    '/_auth/operator/deliveries': {
      id: '/_auth/operator/deliveries'
      path: '/deliveries'
      fullPath: '/operator/deliveries'
      preLoaderRoute: typeof AuthOperatorDeliveriesRouteImport
      parentRoute: typeof AuthOperatorRoute
    }
    '/_auth/operator/dashboard': {
      id: '/_auth/operator/dashboard'
      path: '/dashboard'
      fullPath: '/operator/dashboard'
      preLoaderRoute: typeof AuthOperatorDashboardRouteImport
      parentRoute: typeof AuthOperatorRoute
    }
    '/_auth/operator/copilot-settings': {
      id: '/_auth/operator/copilot-settings'
      path: '/copilot-settings'
      fullPath: '/operator/copilot-settings'
      preLoaderRoute: typeof AuthOperatorCopilotSettingsRouteImport
      parentRoute: typeof AuthOperatorRoute
    }
    '/_auth/operator/compliance': {
      id: '/_auth/operator/compliance'
      path: '/compliance'
      fullPath: '/operator/compliance'
      preLoaderRoute: typeof AuthOperatorComplianceRouteImport
      parentRoute: typeof AuthOperatorRoute
    }
    '/_auth/operator/catalog': {
      id: '/_auth/operator/catalog'
      path: '/catalog'
      fullPath: '/operator/catalog'
      preLoaderRoute: typeof AuthOperatorCatalogRouteImport
      parentRoute: typeof AuthOperatorRoute
    }
    '/_auth/operator/calendar': {
      id: '/_auth/operator/calendar'
      path: '/calendar'
      fullPath: '/operator/calendar'
      preLoaderRoute: typeof AuthOperatorCalendarRouteImport
      parentRoute: typeof AuthOperatorRoute
    }
    '/_auth/operator/broadcasts': {
      id: '/_auth/operator/broadcasts'
      path: '/broadcasts'
      fullPath: '/operator/broadcasts'
      preLoaderRoute: typeof AuthOperatorBroadcastsRouteImport
      parentRoute: typeof AuthOperatorRoute
    }
    '/_auth/operator/audit-logs': {
      id: '/_auth/operator/audit-logs'
      path: '/audit-logs'
      fullPath: '/operator/audit-logs'
      preLoaderRoute: typeof AuthOperatorAuditLogsRouteImport
      parentRoute: typeof AuthOperatorRoute
    }
    '/_auth/operator/ai-search': {
      id: '/_auth/operator/ai-search'
      path: '/ai-search'
      fullPath: '/operator/ai-search'
      preLoaderRoute: typeof AuthOperatorAiSearchRouteImport
      parentRoute: typeof AuthOperatorRoute
    }
    '/_auth/operator/payments/': {
      id: '/_auth/operator/payments/'
      path: '/payments'
      fullPath: '/operator/payments/'
      preLoaderRoute: typeof AuthOperatorPaymentsIndexRouteImport
      parentRoute: typeof AuthOperatorRoute
    }
    '/_auth/operator/orders/': {
      id: '/_auth/operator/orders/'
      path: '/orders'
      fullPath: '/operator/orders/'
      preLoaderRoute: typeof AuthOperatorOrdersIndexRouteImport
      parentRoute: typeof AuthOperatorRoute
    }
    '/_auth/operator/customers/': {
      id: '/_auth/operator/customers/'
      path: '/customers'
      fullPath: '/operator/customers/'
      preLoaderRoute: typeof AuthOperatorCustomersIndexRouteImport
      parentRoute: typeof AuthOperatorRoute
    }
    '/_auth/operator/conversations/': {
      id: '/_auth/operator/conversations/'
      path: '/conversations'
      fullPath: '/operator/conversations/'
      preLoaderRoute: typeof AuthOperatorConversationsIndexRouteImport
      parentRoute: typeof AuthOperatorRoute
    }
    '/_auth/operator/bookings/': {
      id: '/_auth/operator/bookings/'
      path: '/bookings'
      fullPath: '/operator/bookings/'
      preLoaderRoute: typeof AuthOperatorBookingsIndexRouteImport
      parentRoute: typeof AuthOperatorRoute
    }
    '/_auth/operator/payments/$id': {
      id: '/_auth/operator/payments/$id'
      path: '/payments/$id'
      fullPath: '/operator/payments/$id'
      preLoaderRoute: typeof AuthOperatorPaymentsIdRouteImport
      parentRoute: typeof AuthOperatorRoute
    }
    '/_auth/operator/orders/$id': {
      id: '/_auth/operator/orders/$id'
      path: '/orders/$id'
      fullPath: '/operator/orders/$id'
      preLoaderRoute: typeof AuthOperatorOrdersIdRouteImport
      parentRoute: typeof AuthOperatorRoute
    }
    '/_auth/operator/customers/$id': {
      id: '/_auth/operator/customers/$id'
      path: '/customers/$id'
      fullPath: '/operator/customers/$id'
      preLoaderRoute: typeof AuthOperatorCustomersIdRouteImport
      parentRoute: typeof AuthOperatorRoute
    }
    '/_auth/operator/conversations/$id': {
      id: '/_auth/operator/conversations/$id'
      path: '/conversations/$id'
      fullPath: '/operator/conversations/$id'
      preLoaderRoute: typeof AuthOperatorConversationsIdRouteImport
      parentRoute: typeof AuthOperatorRoute
    }
    '/_auth/operator/bookings/$id': {
      id: '/_auth/operator/bookings/$id'
      path: '/bookings/$id'
      fullPath: '/operator/bookings/$id'
      preLoaderRoute: typeof AuthOperatorBookingsIdRouteImport
      parentRoute: typeof AuthOperatorRoute
    }
  }
}

interface AuthOperatorRouteChildren {
  AuthOperatorAiSearchRoute: typeof AuthOperatorAiSearchRoute
  AuthOperatorAuditLogsRoute: typeof AuthOperatorAuditLogsRoute
  AuthOperatorBroadcastsRoute: typeof AuthOperatorBroadcastsRoute
  AuthOperatorCalendarRoute: typeof AuthOperatorCalendarRoute
  AuthOperatorCatalogRoute: typeof AuthOperatorCatalogRoute
  AuthOperatorComplianceRoute: typeof AuthOperatorComplianceRoute
  AuthOperatorCopilotSettingsRoute: typeof AuthOperatorCopilotSettingsRoute
  AuthOperatorDashboardRoute: typeof AuthOperatorDashboardRoute
  AuthOperatorDeliveriesRoute: typeof AuthOperatorDeliveriesRoute
  AuthOperatorFlowsRoute: typeof AuthOperatorFlowsRoute
  AuthOperatorIntegrationsRoute: typeof AuthOperatorIntegrationsRoute
  AuthOperatorNoShowsRoute: typeof AuthOperatorNoShowsRoute
  AuthOperatorOnboardingRoute: typeof AuthOperatorOnboardingRoute
  AuthOperatorPhoneHealthRoute: typeof AuthOperatorPhoneHealthRoute
  AuthOperatorReviewsRoute: typeof AuthOperatorReviewsRoute
  AuthOperatorServicesRoute: typeof AuthOperatorServicesRoute
  AuthOperatorSettingsRoute: typeof AuthOperatorSettingsRoute
  AuthOperatorStaffRoute: typeof AuthOperatorStaffRoute
  AuthOperatorTemplatesRoute: typeof AuthOperatorTemplatesRoute
  AuthOperatorWaitlistRoute: typeof AuthOperatorWaitlistRoute
  AuthOperatorIndexRoute: typeof AuthOperatorIndexRoute
  AuthOperatorBookingsIdRoute: typeof AuthOperatorBookingsIdRoute
  AuthOperatorConversationsIdRoute: typeof AuthOperatorConversationsIdRoute
  AuthOperatorCustomersIdRoute: typeof AuthOperatorCustomersIdRoute
  AuthOperatorOrdersIdRoute: typeof AuthOperatorOrdersIdRoute
  AuthOperatorPaymentsIdRoute: typeof AuthOperatorPaymentsIdRoute
  AuthOperatorBookingsIndexRoute: typeof AuthOperatorBookingsIndexRoute
  AuthOperatorConversationsIndexRoute: typeof AuthOperatorConversationsIndexRoute
  AuthOperatorCustomersIndexRoute: typeof AuthOperatorCustomersIndexRoute
  AuthOperatorOrdersIndexRoute: typeof AuthOperatorOrdersIndexRoute
  AuthOperatorPaymentsIndexRoute: typeof AuthOperatorPaymentsIndexRoute
}

const AuthOperatorRouteChildren: AuthOperatorRouteChildren = {
  AuthOperatorAiSearchRoute: AuthOperatorAiSearchRoute,
  AuthOperatorAuditLogsRoute: AuthOperatorAuditLogsRoute,
  AuthOperatorBroadcastsRoute: AuthOperatorBroadcastsRoute,
  AuthOperatorCalendarRoute: AuthOperatorCalendarRoute,
  AuthOperatorCatalogRoute: AuthOperatorCatalogRoute,
  AuthOperatorComplianceRoute: AuthOperatorComplianceRoute,
  AuthOperatorCopilotSettingsRoute: AuthOperatorCopilotSettingsRoute,
  AuthOperatorDashboardRoute: AuthOperatorDashboardRoute,
  AuthOperatorDeliveriesRoute: AuthOperatorDeliveriesRoute,
  AuthOperatorFlowsRoute: AuthOperatorFlowsRoute,
  AuthOperatorIntegrationsRoute: AuthOperatorIntegrationsRoute,
  AuthOperatorNoShowsRoute: AuthOperatorNoShowsRoute,
  AuthOperatorOnboardingRoute: AuthOperatorOnboardingRoute,
  AuthOperatorPhoneHealthRoute: AuthOperatorPhoneHealthRoute,
  AuthOperatorReviewsRoute: AuthOperatorReviewsRoute,
  AuthOperatorServicesRoute: AuthOperatorServicesRoute,
  AuthOperatorSettingsRoute: AuthOperatorSettingsRoute,
  AuthOperatorStaffRoute: AuthOperatorStaffRoute,
  AuthOperatorTemplatesRoute: AuthOperatorTemplatesRoute,
  AuthOperatorWaitlistRoute: AuthOperatorWaitlistRoute,
  AuthOperatorIndexRoute: AuthOperatorIndexRoute,
  AuthOperatorBookingsIdRoute: AuthOperatorBookingsIdRoute,
  AuthOperatorConversationsIdRoute: AuthOperatorConversationsIdRoute,
  AuthOperatorCustomersIdRoute: AuthOperatorCustomersIdRoute,
  AuthOperatorOrdersIdRoute: AuthOperatorOrdersIdRoute,
  AuthOperatorPaymentsIdRoute: AuthOperatorPaymentsIdRoute,
  AuthOperatorBookingsIndexRoute: AuthOperatorBookingsIndexRoute,
  AuthOperatorConversationsIndexRoute: AuthOperatorConversationsIndexRoute,
  AuthOperatorCustomersIndexRoute: AuthOperatorCustomersIndexRoute,
  AuthOperatorOrdersIndexRoute: AuthOperatorOrdersIndexRoute,
  AuthOperatorPaymentsIndexRoute: AuthOperatorPaymentsIndexRoute,
}

const AuthOperatorRouteWithChildren = AuthOperatorRoute._addFileChildren(
  AuthOperatorRouteChildren,
)

interface AuthRouteChildren {
  AuthOperatorRoute: typeof AuthOperatorRouteWithChildren
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthOperatorRoute: AuthOperatorRouteWithChildren,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
  SignInRoute: SignInRoute,
  BBusinessIdRoute: BBusinessIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
